import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDfAloz_YGhcQIHrnOar0y99h9FRqy1UzU",
  authDomain: "mbfloripaturismo.firebaseapp.com",
  projectId: "mbfloripaturismo",
  storageBucket: "mbfloripaturismo.firebasestorage.app",
  messagingSenderId: "806220889764",
  appId: "1:806220889764:web:10a11620fe97603473b031",
  measurementId: "G-P3CWGWND3X",
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const auth = getAuth(app);
const messaging = getMessaging(app);
const storage = getStorage(app);

export { app, database, auth, messaging, storage };
